<template>
  <PflegeBaseSectionTemplate
    v-editable="props.blok"
    :background-color="getPflegeColornameFromHex(props.blok.backgroundColor.value)"
    :data-uid="props.blok._uid"
    :anchor="anchor"
    :text-align="props.blok.textAlign"
  >
    <template v-if="props.blok.media?.length > 0" #media>
      <Media
        :blok="props.blok.media[0]"
        :aspect-ratio="{
          desktop: aspectRatios.xs,
          tablet: aspectRatios.s,
          mobile: aspectRatios.s
        }"
      />
    </template>

    <template v-if="props.blok.intro?.length > 0" #intro>
      <IntroComponent :blok="props.blok.intro[0]" />
    </template>
    <template v-if="hasContent" #content>
      <StoryblokComponent
        v-for="copy in props.blok.copy"
        :key="copy._uid"
        :blok="copy"
      />
      <template v-for="content in props.blok.button">
        <Button
          v-if="content.component === 'WPElementButton'"
          :key="content._uid"
          :blok="content"
        />
      </template>
    </template>

    <template v-if="props.blok.secondDivider?.length > 0" #secondDivider>
      <Divider :blok="props.blok.secondDivider[0]" />
    </template>

    <template v-if="props.blok.closing?.length > 0" #closing>
      <ClosingComponent :blok="props.blok.closing[0]" />
    </template>

    <template v-if="props.blok.thirdDivider?.length > 0" #thirdDivider>
      <Divider :blok="props.blok.thirdDivider[0]" />
    </template>
  </PflegeBaseSectionTemplate>
</template>

<script setup>
import { WPElementButton, WPElementMedia } from '@webcarelbj/shared-bloks'
import { findComponent } from '@webcarelbj/shared-components'

const Button = findComponent(WPElementButton)
const Media = findComponent( WPElementMedia)

const props = defineProps({
  blok: {
    type: Object,
    required: true,
  },
})
const anchor = computed(() => {
  return props.blok.intro?.length > 0 && props.blok.intro[0].anchor !== null
    ? props.blok.intro[0].anchor
    : ''
})
const hasContent = props.blok.copy.length > 0 || props.blok.button.length > 0
const { getPflegeColornameFromHex } = usePflegeUtils()
</script>
